import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';

import { createNlsMiddleware, documentapi } from '@holmescorp/lcc-state';

import css from '../css/progress-view.m.css';
import { Breadcrumbs } from './index';
import AllTestsPanel from './panels/all-tests';
import FinalTestPanel from './panels/final-test';

const factory = create({
	nls: createNlsMiddleware('ditabook'),
	theme,
	documentapi
});

export const ProgressView = factory(({ id, middleware: { theme, documentapi, nls } }) => {
	const {
		messages: { my_progress_title = 'My Progress' }
	} = nls();

	const themeCss = theme.classes(css);

	documentapi.setTitle(my_progress_title);

	return v('div', { id, classes: [theme.variant(), themeCss.root] }, [
		w(Breadcrumbs, {}),
		v('div', { classes: [themeCss.content] }, [w(FinalTestPanel, {}), w(AllTestsPanel, {})])
	]);
});

export default ProgressView;
